export default "__VITE_ASSET__Bne7dMOg__"